import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=41848c3a&scoped=true&"
import script from "./ViewData.vue?vue&type=script&lang=js&"
export * from "./ViewData.vue?vue&type=script&lang=js&"
import style0 from "./ViewData.vue?vue&type=style&index=0&id=41848c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41848c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41848c3a')) {
      api.createRecord('41848c3a', component.options)
    } else {
      api.reload('41848c3a', component.options)
    }
    module.hot.accept("./ViewData.vue?vue&type=template&id=41848c3a&scoped=true&", function () {
      api.rerender('41848c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/data/ViewData.vue"
export default component.exports